import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraListPage, SpecraPageHeader } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { usePursuitRecord } from './PursuitRecordContext';
/**
 * Frame for every pursuit section page (GRW-15 item 7): SpecraListPage with a
 * UI-size page header. `capture.workspaceRoot` + `data-capture-id` stay on the
 * root because ~21 journeys wait for them.
 */ export function PursuitSectionFrame({ title, actions, children }) {
    const { captureProjectId } = usePursuitRecord();
    return /*#__PURE__*/ _jsx(SpecraListPage, {
        "data-capture-id": captureProjectId,
        "data-testid": Testids.capture.workspaceRoot,
        header: /*#__PURE__*/ _jsx(SpecraPageHeader, {
            actions: actions,
            title: title,
            titleSize: "ui"
        }),
        padding: "page",
        children: /*#__PURE__*/ _jsx("div", {
            className: "space-y-4",
            children: children
        })
    });
}
